const cards = [
  {
    image: 'https://readdy.ai/api/search-image?query=A%20dark%20atmospheric%20digital%20content%20dashboard%20with%20warm%20orange%20and%20amber%20accent%20highlights%2C%20trending%20data%20cards%20floating%20in%20a%20futuristic%20interface%2C%20glowing%20labels%20and%20metrics%2C%20cinematic%20mood%20lighting%2C%20premium%20editorial%20aesthetic%2C%20dark%20gradient%20background&width=600&height=400&seq=card-img-01&orientation=landscape',
    title: '51黑料最新发布 — 六月热点全景回顾',
    desc: '聚合51黑料网最新发布内容，涵盖本月所有热门话题与讨论焦点，一站浏览不遗漏。',
    label: '最新',
    labelColor: 'primary' as const,
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20sleek%20dark%20themed%20portal%20gateway%20with%20multiple%20glowing%20entry%20points%20in%20orange%20and%20amber%20tones%2C%20digital%20navigation%20hub%20concept%2C%20floating%20labels%20with%20trending%20topics%2C%20modern%20minimalist%20design%2C%20warm%20accent%20lighting%2C%20dark%20background&width=600&height=400&seq=card-img-02&orientation=landscape',
    title: '91黑料入口导航 — 安全直达指南',
    desc: '最新91黑料网入口地址汇总，确保安全稳定访问，随时获取91黑料吃瓜最新动态。',
    label: '热门',
    labelColor: 'accent' as const,
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20dynamic%20video%20content%20wall%20with%20multiple%20thumbnail%20cards%20arranged%20in%20a%20grid%2C%20warm%20orange%20and%20dark%20themed%20interface%2C%20play%20button%20overlays%2C%20trending%20labels%2C%20cinematic%20lighting%2C%20premium%20content%20platform%20aesthetic&width=600&height=400&seq=card-img-03&orientation=landscape',
    title: '17黑料吃瓜视频 — 精选内容合集',
    desc: '17黑料网最新吃瓜视频精选，热门实况追踪与精彩回顾，更新频率高、内容覆盖广。',
    label: '视频',
    labelColor: 'secondary' as const,
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20dark%20themed%20archive%20collection%20display%20with%20multiple%20layered%20content%20cards%20in%20warm%20amber%20and%20orange%20tones%2C%20organized%20catalog%20interface%2C%20digital%20library%20concept%2C%20glowing%20category%20labels%2C%20editorial%20style&width=600&height=400&seq=card-img-04&orientation=landscape',
    title: '718黑料合集 — 完整系列归档',
    desc: '718黑料全系列合集整理，按时间线与热度排序，方便回溯查找所有经典内容。',
    label: '合集',
    labelColor: 'primary' as const,
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20real-time%20discussion%20tracker%20interface%20with%20glowing%20data%20streams%20in%20orange%20and%20amber%2C%20trending%20topic%20cards%20updating%20dynamically%2C%20dark%20futuristic%20design%2C%20warm%20accent%20colors%2C%20editorial%20quality&width=600&height=400&seq=card-img-05&orientation=landscape',
    title: '黑料51讨论区 — 今日热议话题',
    desc: '黑料51社区今日最热门讨论话题汇总，实时追踪用户关注焦点与讨论风向。',
    label: '热议',
    labelColor: 'accent' as const,
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20glowing%20trending%20chart%20display%20with%20orange%20and%20amber%20gradient%20bars%2C%20data%20visualization%20in%20dark%20theme%2C%20ranking%20labels%20and%20metrics%2C%20modern%20dashboard%20aesthetic%2C%20warm%20lighting%2C%20clean%20composition&width=600&height=400&seq=card-img-06&orientation=landscape',
    title: '本周人气飙升 — 91黑料吃瓜速报',
    desc: '本周91黑料网吃瓜内容热度飙升榜单，覆盖最新事件追踪与用户最关注话题。',
    label: '飙升',
    labelColor: 'primary' as const,
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20dark%20themed%20navigation%20compass%20with%20multiple%20glowing%20portal%20rings%20in%20warm%20orange%20and%20amber%2C%20digital%20gateway%20concept%2C%20abstract%20geometric%20patterns%2C%20futuristic%20entry%20points%2C%20cinematic%20atmosphere&width=600&height=400&seq=card-img-07&orientation=landscape',
    title: '数字黑料全品牌入口 — 一站直达',
    desc: '覆盖51黑料、91黑料、17黑料、718黑料等全部子品牌入口，最新地址实时更新保证可访问。',
    label: '入口',
    labelColor: 'secondary' as const,
  },
];

const labelClasses: Record<string, string> = {
  primary: 'bg-primary-500 text-background-50',
  accent: 'bg-accent-500 text-background-50',
  secondary: 'bg-secondary-500 text-background-50',
};

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">图文精选</h2>
          <p className="mt-2 text-sm text-foreground-600">黑料系列品牌精彩内容一站式浏览</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.map((card, idx) => (
            <article
              key={idx}
              className={`group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200/40 transition-all cursor-pointer ${
                idx === 0 ? 'sm:col-span-2 lg:col-span-2' : ''
              }`}
            >
              <div className={`relative overflow-hidden ${idx === 0 ? 'aspect-[16/7]' : 'aspect-[16/10]'}`}>
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-900/40 to-transparent"></div>
                <span className={`absolute top-3 left-3 px-2.5 py-1 rounded-md text-xs font-bold whitespace-nowrap ${labelClasses[card.labelColor]}`}>
                  {card.label}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base font-bold font-heading text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {card.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">{card.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}